import { render, staticRenderFns } from "./CreateInvestorMenu.vue?vue&type=template&id=c95d7872"
import script from "./CreateInvestorMenu.vue?vue&type=script&lang=js"
export * from "./CreateInvestorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports